import { render, staticRenderFns } from "./ConteudoPageForm.vue?vue&type=template&id=6a201633&scoped=true"
import script from "./ConteudoPageForm.vue?vue&type=script&lang=js"
export * from "./ConteudoPageForm.vue?vue&type=script&lang=js"
import style0 from "./ConteudoPageForm.vue?vue&type=style&index=0&id=6a201633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a201633",
  null
  
)

export default component.exports